import api from '../../api';

// Fetch elective groups with term support
export const fetchElectiveGroups = async (params, token) => {
  const { tenantId, departmentId, academicYearId, semesterId, termId, classId, groupCategory } = params;
  let url = `/api/elective-groups?tenantId=${tenantId}&departmentId=${departmentId}`;
  if (academicYearId) url += `&academicYearId=${academicYearId}`;
  if (semesterId) url += `&semesterId=${semesterId}`;
  if (termId) url += `&termId=${termId}`; // NEW: term support
  if (classId) url += `&classId=${classId}`;
  if (groupCategory) url += `&groupCategory=${groupCategory}`;
  
  const response = await api.get(url, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data.data || [];
};

// Create elective group with term support
export const createElectiveGroup = async (data, token) => {
  const response = await api.post('/api/elective-groups', data, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Update elective group with term support
export const updateElectiveGroup = async (id, data, token) => {
  const response = await api.put(`/api/elective-groups/${id}`, data, {
    headers: { Authorization: `Bearer ${token}` }
  });
  return response.data;
};

// Delete elective group
export const deleteElectiveGroup = async (id, tenantId, token) => {
  const response = await api.delete(`/api/elective-groups/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
    data: { tenantId }
  });
  return response.data;
};